import {Button, Col, Container, Row, Spinner, Alert, Card, Figure} from 'react-bootstrap';
import Navbar from "react-bootstrap/Navbar";
import logoImg from "../assets/netcomet3.png";
import {useEffect, useState} from "react";
import {api} from "../services/Api";
import CryptoJS from "crypto-js";
import {useAlert} from "../contexts/AlertContext";
import {Input} from "../components/Input/Input";
import {cpfMask, phoneMask} from "../Utils/Mask";

interface ParametersProps {
	hbo: number;
	paramount: number;
	watch: number;
	exitlag: number;
    playhub: number;
}

export function EnableStreaming() {

	const url = window.location.href.split('ativacao-streaming/');
	const token = url[1];

	const [parameters, setParameters] = useState<ParametersProps>({hbo: 0, paramount: 0, watch: 0, exitlag: 0, playhub: 0});
	const [loading, setLoading] = useState<boolean>(true);
	const [servicesToAdd, setServicesToAdd] = useState<[]>([]);
	const [servicesToRemove, setServicesToRemove] = useState<[]>([]);
	const [servicesMigrate, setServicesMigrate] = useState<[]>([]);
	const [tokenUrl, setTokenUrl] = useState<string>('');
	const [urlLink, setUrlLink] = useState<string>('acoes-link-cliente');
	const [error, setError] = useState<string>('');
	const [success, setSuccess] = useState<string>('');
	const [document, setDocument] = useState<string>('');
	const [email, setEmail] = useState<string>('');
	const [telefone, setTelefone] = useState<string>('');

	const { handleSetAlert } = useAlert();

	useEffect(() => {
		let obj_json = JSON.parse(atob(token));

		let dataParameters: {
			dbn: string,
			servicos_adicionar: [],
			servicos_remover: [],
			servicos_migrar: []
		};

		if (obj_json.ciphertext) {
			let key = CryptoJS.PBKDF2(process.env.REACT_APP_SUPERGER_API_AUTHENTICATION_TOKEN_KEY as string, process.env.REACT_APP_SUPERGER_API_AUTHENTICATION_TOKEN_SALT as string, {
				hasher: CryptoJS.algo.SHA512,
				keySize: 64 / 8,
				iterations: 999
			});
			let decrypted = CryptoJS.AES.decrypt(obj_json.ciphertext, key, {iv: CryptoJS.enc.Hex.parse(process.env.REACT_APP_SUPERGER_API_AUTHENTICATION_TOKEN_IV_HEX as string)});
			dataParameters = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8))

			let headers = {
				'Content-Type': 'application/json',
			};

			let data = {
				token: token,
				servicos_adicionar: dataParameters?.servicos_adicionar,
				servicos_remover: dataParameters?.servicos_remover,
				servicos_migrar: dataParameters?.servicos_migrar
			}

			setServicesToAdd(dataParameters?.servicos_adicionar);
			setServicesToRemove(dataParameters?.servicos_remover);
			setServicesMigrate(dataParameters?.servicos_migrar);
			setTokenUrl(token);

			api.post('v1/provedor/streaming/exibir-link-cliente', data, {headers})
				.then((response: any) => {
					if (!response.data.dados?.servicos_executados) {
						setParameters(response.data.dados);
						setLoading(false);
					} else {
						setSuccess('Todos os serviços já estão ativos')
						setLoading(false);
					}
				}).catch((e) => {
					setError('Não foi possível exibir o link. Para mais informações entre em contato com a nossa central de atendimento no telefone '+process.env.REACT_APP_SUPERGER_TELEFONE)
					setLoading(false);
				});
		} else {
			dataParameters = obj_json;

			let headers = {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer '+obj_json?.token
			};

			let data = {
				servicos_adicionar: dataParameters?.servicos_adicionar,
				servicos_remover: dataParameters?.servicos_remover,
				servicos_migrar: dataParameters?.servicos_migrar
			}

			setServicesToAdd(dataParameters?.servicos_adicionar);
			setServicesToRemove(dataParameters?.servicos_remover);
			setServicesMigrate(dataParameters?.servicos_migrar);
			setTokenUrl(obj_json?.token);
			setUrlLink('acoes-link');

			api.post('v1/provedor/streaming/exibir-link', data, {headers})
				.then((response: any) => {
					if (!response.data.dados?.servicos_executados) {
						setParameters(response.data.dados);
						setLoading(false);
					} else {
						setSuccess('Todos os streamings já foram executados!')
						setLoading(false);
					}
				}).catch(() => {
					setError('Não foi possível exibir o link. Para mais informações entre em contato com a nossa central de atendimento no telefone '+process.env.REACT_APP_SUPERGER_TELEFONE)
					setLoading(false);
				});
		}
	},[token])

	function handleActivate() {
		if (tokenUrl) {
			if (!document) {
				handleSetAlert({
					visible: true,
					variant: 'danger',
					message: 'Informe o CPF',
					timeout: 5000
				});
				return false;
			} else if (!email) {
				handleSetAlert({
					visible: true,
					variant: 'danger',
					message: 'Informe o email',
					timeout: 5000
				});
				return false;
			} else if (!telefone) {
				handleSetAlert({
					visible: true,
					variant: 'danger',
					message: 'Informe o telefone',
					timeout: 5000
				});
				return false;
			}

			let regexTel = /^\(\d{2}\) \d{5}-\d{3,4}$/;
			if (!regexTel.test(telefone)) {
				handleSetAlert({
					visible: true,
					variant: 'danger',
					message: 'Telefone inválido',
					timeout: 5000
				});
				return false;
			}

			let regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			if (!regex.test(email)) {
				handleSetAlert({
					visible: true,
					variant: 'danger',
					message: 'Email inválido',
					timeout: 5000
				});
				return false;
			}

			setLoading(true);

			const headers = {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer '+tokenUrl
			};

			let data = {
				token: tokenUrl,
				cpf: document,
				email: email,
				telefone: telefone,
				servicos_adicionar: servicesToAdd,
				servicos_remover: servicesToRemove,
				servicos_migrar: servicesMigrate,
			}

			api.post('v1/provedor/streaming/'+urlLink, data, {headers})
				.then(() => {
                    if (parameters.watch === 1 && parameters.playhub === 0) {
                        setSuccess('Benefícios executados com sucesso! Você irá receber um email com as instruções para acessar o serviço');
                    } else {
                        setSuccess('Benefícios executados com sucesso!')
                    }
					setLoading(false);
				}).catch((error) => {
					if (error.response.data.message === 'CPF não confere') {
						setError('CPF não confere com o titular do contrato!');
					} else {
						setError('Não foi possível ativar o link. Para mais informações entre em contato com a nossa central de atendimento no telefone '+process.env.REACT_APP_SUPERGER_TELEFONE)
					}
					setLoading(false);
				});
		}
	}

    const isMobile = window.innerWidth <= 768;

    return(
		<>
			<Navbar collapseOnSelect style={{height: 80}} className="header p1" expand="lg">
				<Container>
					<Navbar.Brand>
                        <img src={logoImg} alt="Logo Netcomet" width={isMobile ? 130 : 160}/>
                    </Navbar.Brand>
				</Container>
			</Navbar>
			<Container className="container-login p-3">
				{(loading || (!loading && (error || success))) && <Row className="h-100">
					<Col md={12} className="align-self-center">
						{loading && <div className="justify-content-center align-items-center d-flex">
							<Spinner animation="border" role="status"/>
						</div>
						}
						{!loading && error && <div className="justify-content-center align-items-center d-flex">
							<Alert variant="danger" className="d-flex align-items-center"><span className="material-icons title-icon">error</span>{error}</Alert>
						</div>}
                        {!loading && success && (
                            <div className="justify-content-center align-items-center d-flex">
                                <Alert variant="success" className="d-flex flex-column align-items-center text-center">

                                    <div className="d-flex align-items-center">
                                        <span className="material-icons title-icon">check</span>
                                        {success}
                                    </div>

                                    {parameters.playhub === 1 && (
                                        <div className="mt-3">
                                            <div className="mb-2">
                                                Para acessar os streamings, acesse o link abaixo e informe o telefone de cadastro
                                            </div>

                                            <Button
                                                variant="light"
                                                onClick={() =>
                                                    window.open(
                                                        "https://www.portaldoassinante.com/netcomet/login",
                                                        "_blank"
                                                    )
                                                }
                                            >
                                                Acessar Portal do Assinante
                                            </Button>
                                        </div>
                                    )}

                                </Alert>
                            </div>
                        )}
					</Col>
				</Row>}
				{!loading && !error && !success && <Row className="h-100">
					<Col md={12} className="align-self-center">
						<Row className="justify-content-center mb-3">
							<Container className="d-flex justify-content-center">
								<Col md={7}>
									<Card className="p-3">
                                        <Col md={12} style={{height: 120}} className="justify-content-center d-flex align-items-center text-center">
                                            <Col md={3} sm={3} xs={3}>
                                                <Figure>
                                                    <Figure.Image
                                                        width={200}
                                                        height={200}
                                                        alt="200x210"
                                                        src={logoImg}
                                                        style={{margin: 0}}
                                                    />
                                                </Figure>
                                            </Col>
                                        </Col>
										<Col md={12} className="d-flex w-100 mb-4 justify-content-center">
											<Col md={12} sm={12} xs={12} className="text-center">
												<p style={{fontSize: 18}}>
													<b>
														Olá, para começar a desfrutar do nosso serviço de streaming,
														solicitamos que você nos forneça o CPF do titular, seu endereço de email e número de telefone
													</b>
												</p>
											</Col>
										</Col>
										<Col md={12} className="d-flex w-100 mb-4 justify-content-center">
											<Col md={12} sm={12} xs={12}>
												<div className="mb-4 w-100">
													<Input
														icon="face"
														type="tel"
														placeholder="CPF do titular"
														onChange={value => setDocument(cpfMask(value.target.value.trim()))}
														value={document}
													/>
												</div>
											</Col>
										</Col>
										<Col md={12} className="d-flex w-100 mb-4 justify-content-center">
											<Col md={12} sm={12} xs={12}>
												<div className="mb-4 w-100">
													<Input
														icon="email"
														type="text"
														placeholder="Email para ativação"
														onChange={(value) => {setEmail(value.target.value.trim())}}
														value={email}
													/>
												</div>
											</Col>
										</Col>
										<Col md={12} className="d-flex w-100 mb-4 justify-content-center">
											<Col md={12} sm={12} xs={12}>
												<div className="mb-4 w-100">
													<Input
														icon="phone"
														type="tel"
														placeholder="Número de telefone para ativação"
														onChange={(value) => {setTelefone(phoneMask(value.target.value.trim()))}}
														value={telefone}
													/>
												</div>
											</Col>
										</Col>
										<Col md={12} className="d-flex w-100 mb-4 justify-content-center">
											<Col md={12} sm={12} xs={12}>
												<Button variant="success" className="w-100" onClick={handleActivate}>Executar</Button>
											</Col>
										</Col>
									</Card>
								</Col>
							</Container>
						</Row>
					</Col>
				</Row>}
			</Container>
		</>
	);
}
